import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { MatTableDataSource } from '@angular/material/table';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-param-coll',
  templateUrl: './param-coll.component.html',
  styleUrls: ['./param-coll.component.scss'],
})
export class ParamCollComponent implements OnInit {
  successLoadData = false;
  data = { DiverSys_Index: '', DiverSys_Titre: '', DiverSys_Libelle: '' };
  dataSource;
  displayedColumns = ['DiverSys_Index', 'DiverSys_Titre', 'DiverSys_Libelle'];

  showParamColl = true;
  buttonModifier = { show: true, text: 'Modifier' };
  buttonConsulter = { show: false, text: '' };
  buttonSupprimer = { show: true, text: 'Suprimer' };
  showInoutTab = {
    DiverSys_Index: true,
    DiverSys_Titre: true,
    DiverSys_Libelle: true,
  };
  ds;
  exist = true;
  disabledBtnAjouter: boolean = false;
  disabledBtnModifier: boolean = false;
  constructor(public generalService: GeneralService) {}

  ngOnInit() {
    this.setDataSource(false);
  }
  ajouter(f) {
    if (f.form.valid) {
      this.disabledBtnAjouter = true;
      this.exist = false;
      this.generalService.rechercheTable(globalUrls.urlParametre).subscribe(
        (data) => {
          data.DiverSys[0].DiverSys_Type = 'col01';
          data.DiverSys[0].DiverSys_Index = this.data.DiverSys_Index;
          data.DiverSys[0].DiverSys_Libelle = this.data.DiverSys_Libelle;
          data.DiverSys[0].DiverSys_Titre = this.data.DiverSys_Titre;
          this.generalService.enregisterTable(data).subscribe(
            (saveData) => {
              this.disabledBtnAjouter = false;
              this.setDataSource(true);
            },
            (err) => {
              this.exist = true;
              this.disabledBtnAjouter = false;
            }
          );
        },
        (err) => {
          this.exist = true;
          this.disabledBtnAjouter = false;
        }
      );
    }
  }
  setDataSource(showMessage) {
    this.exist = false;
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=col01')
      .subscribe((data) => {
        this.ds = data;
        this.dataSource = new MatTableDataSource(data.DiverSys);
        this.successLoadData = true;
        this.exist = true;
        if (showMessage) {
          this.generalService.dialogSuccess('Enregistré', true);
        }
      });
    //   this.dataSource=[
    //   {DiverSys_Index:"01",DiverSys_Titre:"salarier",DiverSys_Libelle:""},
    //   {DiverSys_Index:"02",DiverSys_Titre:"Directeur",DiverSys_Libelle:""}];
    //   this.successLoadData = true;
  }
  modifier() {
    this.exist = false;
    this.disabledBtnModifier = true;
    this.generalService.enregisterTable(this.ds).subscribe(
      (data) => {
        this.exist = true;
        this.disabledBtnModifier = false;
        this.setDataSource(true);
      },
      (err) => {
        this.generalService.dialogSuccess('Non enregister', false);
        this.exist = true;
      }
    );
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  supprimer() {}
  selectRow(event, row) {
    var els = document.getElementsByClassName('mat-row');
    Array.prototype.forEach.call(els, function (el) {
      el.style = '';
    });
    event.currentTarget.style = 'background-color: #a0bdf3;';
  }
}
